module.exports = __webpack_public_path__ + "static/Joystream_Thumbnail_3-c3ba59bdd3325b6382b904fa3b049d00.jpeg";